import { useForm } from "react-hook-form";
import { crearPrograma } from "../../../services/programa.service";
import Swal from "sweetalert2";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { TITULO_PROGRAMA_REG } from "../../../utils/constantes";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllIdiomas } from "../../../services/idioma.service";
import { SubmitButton } from "../../../components/atoms/SubmitButton";
import { FormInput } from "../../../components/molecules/FormInput";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { FormHook } from "../../../components/molecules/FormHook";
import { FormSelect } from "../../../components/atoms/FormSelect";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";
import { crearProgramaIdioma } from "../../../services/programaIdioma.service";

export const RegistrarProgramaPage = () => {
  const navigate = useNavigate();
  const [estaCargando, setEstaCargando] = useState(false);
  const [idiomas, setIdiomas] = useState([]);
  const [idiomasSeleccionados, setIdiomasSeleccionados] = useState([]);
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm();
  const handleIdiomasChange = (selected) => {
    setIdiomasSeleccionados(selected)
  };

  const obtenerIdiomas = async () => {
    await getAllIdiomas()
      .then((idiomas) => {
        setIdiomas(idiomas?.map((idioma) => ({
          value: idioma?.idIdioma,
          label: idioma?.nombre,
        })));
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    obtenerIdiomas();
  }, []);

  const submit = async (data) => {
    setEstaCargando(true);
    try {
      const nuevoPrograma = await crearPrograma(data);

      const programaIdiomaPromises = idiomasSeleccionados.map((idioma) =>
        crearProgramaIdioma({
          idPrograma: nuevoPrograma.idPrograma,
          idIdioma: idioma.value,
        })
      );
      await Promise.all(programaIdiomaPromises);
      showAlert({
        callback: () => navigate("/programas"),
      });
    } catch (err) {
      const errorMessage = err.response.data.message;
      showErrorAlert({ text: errorMessage })
    } finally {
      setEstaCargando(false);
    }
  };

  return (
    <ContenedorPageTemplate
      dirIcono={DIR_ICON_MAT}
      titulo={TITULO_PROGRAMA_REG}
    >
      <FormHook
        handleSubmit={handleSubmit}
        submit={submit}
        className="w-[min(100%,700px)] mx-auto"
      >
        <FormDiv className="md:flex flex-wrap">
          <FormInput
            id="nombre"
            label="Nombre"
            type="text"
            placeholder="Nombre"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: { value: 60, message: "Súpero la cantidad máxima 60 caracteres" },
              minLength: { value: 1, message: "Mínimo 1 caracter" },
            }}
            error={errors.nombre}
            className="md:w-full"
          />
          <FormInput
            id="duracion"
            label="Duracion"
            type="text"
            placeholder="Duracion del programa"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: { value: 60, message: "Súpero la cantidad máxima 20 caracteres" },
              minLength: { value: 1, message: "Mínimo 1 caracter" },
            }}
            error={errors.duracion}
            className="md:w-full"
          />
          <FormInput
            id="totalPrecio"
            label="Costo del programa"
            type="number"
            placeholder="Costo del programa"
            register={register}
            min="0"
            validation={{
              required: { value: true, message: "Campo requerido", },
            }}
            className="md:w-1/2 md:pr-2"

            error={errors.totalPrecio}
          />
          <FormSelect
            name="idiomas"
            label="Idiomas"
            control={control}
            options={idiomas}
            isMulti={true}
            validation={{ required: "Campo requerido" }}
            placeholder="Idiomas"
            handleChange={handleIdiomasChange}
            error={errors.idiomas}
            className="md:w-1/2 md:pl-2"
          />
        </FormDiv>
        <SubmitButton estaCargando={estaCargando} text="Guardar" />
      </FormHook>
    </ContenedorPageTemplate>
  );
};
